const SKIPPED_REASON_LABELS = {
  EMPLOYEE_NOT_FOUND: 'aucun employe Mon Espace ne correspond a ce pseudo Planning',
  MISSING_LOGIN: 'pseudo Planning manquant dans la ligne envoyee',
  MODIFIER_EXPORT_LOCKED: 'heures deja verrouillees par un export Mon Espace',
}

export const describeWorkedHoursSkippedLine = (line = {}) => {
  const identityParts = []
  if (line.initials) identityParts.push(line.initials)
  if (line.login) identityParts.push(`pseudo ${line.login}`)
  if (line.userId) identityParts.push(`id Planning ${line.userId}`)

  const identity = identityParts.length > 0 ? identityParts.join(' / ') : 'ligne sans identite'
  const reason =
    SKIPPED_REASON_LABELS[line.reason] || `raison Mon Espace ${line.reason || 'inconnue'}`

  return `${identity} : ${reason}.`
}

export const buildWorkedHoursSkippedDetails = (skipped) => {
  if (!Array.isArray(skipped)) return []

  return skipped.map(describeWorkedHoursSkippedLine)
}
